import { createSigningFlowSM } from '@/machines/SigningFlowMachine';
import { SIGN_METHOD } from '@treyd-io/core/constants/auth';
import { COUNTRY_SIGN_METHODS } from '@treyd-io/core/constants/country';
import { useMachine } from '@xstate/react';
import { first } from 'lodash';

export const useSigningStateMachine = ({ country }: { country: string }) => {
  const signingFlowMachine = createSigningFlowSM({
    country,
  });
  const [state, send] = useMachine(signingFlowMachine);

  const switchSigningMethod = () => {
    send('changeSigningMethod', {
      signingMethod: state.context.signingMethod.startsWith('bankid')
        ? SIGN_METHOD.OTP
        : first(COUNTRY_SIGN_METHODS[country || 'default']),
    });
  };

  return {
    state,
    switchSigningMethod,
  };
};
